<template>
  <div class="viewCont">
    <NavBar :open="open" :handleOpen="handleOpen"/>
    <RouterRender :handleOpen="handleOpen"/>
  </div>
  <AudioPlayer/>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import AudioPlayer from '@/components/AudioPlayer.vue'
import RouterRender from '@/components/RouterRender.vue'
  export default {
    components:{
      AudioPlayer,
      RouterRender,
      NavBar
    },
    data(){
      return{
        open:false,
      }
    },
    methods:{
      handleOpen(a){
        this.open=a
      }
    }
  }
</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Quicksand&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.1.1/css/all.min.css');

template{
  min-height: 100vh;
}

#app {
  font-family: 'Quicksand', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  --mainred: #E86060;
}

.viewCont{
  position: relative;
  display: flex;
  flex-direction: row;
  height: 100%;
}

img{
  width: 250px;
}

.flex{
  display: flex;
}

.icon{
  font-family: 'Font Awesome 6 Free';
  font-weight: 700;
}

</style>

